import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { LoginService } from 'src/app/login/login.service';
import { MailAccountsService } from '../mail-accounts.service';

@Component({
  selector: 'app-mail-accounts-detail',
  templateUrl: './mail-accounts-detail.component.html',
  styleUrls: ['./mail-accounts-detail.component.scss']
})
export class MailAccountsDetailComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  @ViewChild("formDetails") public formDetails: NgForm;
  public mailAccount: any = {}
  public status: any = "";
  public mail_types: any = [
    { name: "Servidor SMTP", code: "smtp" }
  ];
  public lastGridEvent: any;
  public yesno_options: any = [{ label: "Sí", value: true }, { label: "No", value: false }];
  public mode_options: any = [{ label: "Descargar de Office365", value: "<" }, { label: "Enviar a Office365", value: ">" }, { label: "Sincronizar con Office365", value: "<>" }];

  constructor(
    private mailAccountsService: MailAccountsService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dialogService: DialogService,
    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private loginService: LoginService,
    private coreFormService: CoreFormService
  ) { }

  ngOnInit(): void {
    this.checkPossiblesTypes();
    this.loadData(this.config.data.id);
  }

  checkPossiblesTypes() {
    //Si tiene el feature 34 (Integración Correo/Calendarios office), mete el office365:
    if (this.loginService.hasFeature("34")) this.mail_types.push({ name: "Office365", code: "office365" });

    //Si tiene el feature 42, mete el mailchimp:
    if (this.loginService.hasFeature("42")) this.mail_types.push({ name: "MailChimp", code: "mailchimp" });

    //si tiene el feature 43, metemos mailjet
    if (this.loginService.hasFeature("43")) this.mail_types.push({ name: "Mailjet", code: "mailjet" });
  }

  loadData(id) {
    if (id) {
      this.mailAccountsService.get(id).subscribe(
        data => {
          this.mailAccount = data;
          if (this.mailAccount.connected) { this.status = "Cuenta conectada" } else { this.status = "Cuenta desconectada" }
          var date_last_connection = new Date();
          if (this.mailAccount.last_connection) {
            date_last_connection = new Date(this.mailAccount.last_connection);
            var date_formatted = this.getFormattedDate(date_last_connection);
            this.status += " - Última conexión " + date_formatted;
          };
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    } else {
      this.mailAccount.type = 'smtp';
      //this.mailAccount.mail_out_server = "smtp.gmail.com";
      //this.mailAccount.mail_out_port = 587;
      //this.mailAccount.mail_out_ssl = true;
      this.mailAccount.configuration = {
        mail: {
          enabled: false,
          mode: "<"
        },
        contacts: {
          enabled: false,
          mode: "<"
        },
        calendar: {
          enabled: false,
          mode: "<"
        }
      };
    };
  };
  save(cb:Function=null) {
    if (!this.coreFormService.validate(this.formDetails)) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.mailAccount.id === "undefined") {
      this.mailAccountsService.add(this.mailAccount).subscribe(
        data => {
          this.mailAccount = data;
          this.loadData(this.mailAccount.id);
          this.messageService.add({ closable: false, severity: 'success', summary: "Cuenta de correo añadida correctamente." });
          if (cb != null) {
            cb();
          } else {
            this.dynamicDialogRef.close();
          }
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.mailAccountsService.save(this.mailAccount.id, this.mailAccount).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Cuenta de correo guardada correctamente" });
          if (cb != null) {
            cb();
          } else {
            this.dynamicDialogRef.close();
          }
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la cuenta de correo " + this.mailAccount.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.mailAccountsService.delete(this.mailAccount.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
  isDuplied() {
    if (!this.coreFormService.validate(this.formDetails)) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.mailAccountsService.isDuplied(this.mailAccount).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe una cuenta con los datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save();
        }
      }
    );
  }

  getFormattedDate(date) {
    var date_formatted = this.padDigits(date.getDate())
      + "/"
      + this.padDigits(date.getMonth())
      + "/"
      + date.getFullYear()
      + " "
      + this.padDigits(date.getHours())
      + ":"
      + this.padDigits(date.getMinutes());
    return date_formatted;
  }
  padDigits(num, padding = 2) {
    return num.toString().padStart(padding, '0');
  }

  testAccount() {
    //TODO:
  }

}
